import LoadingSpinner from '@bridebook/web/components/common/loading-spinner/loading-spinner';
import { getMultiShowroundEntryParams } from '@bridebook/web/lib/showrounds/multi-showround/state/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import React from 'react';

const MultiShowroundModalLazy = React.lazy(() =>
  import('./multi-showround-modal').then((module) => ({ default: module.MultiShowroundModal })),
);

const MultiShowroundModal = () => {
  const entryParams = useSelector(getMultiShowroundEntryParams);

  if (!entryParams) {
    return null;
  }

  return (
    <React.Suspense fallback={<LoadingSpinner />}>
      <MultiShowroundModalLazy entryParams={entryParams} />
    </React.Suspense>
  );
};

export default MultiShowroundModal;
